import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {BinaryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/binary-math-operator/geometry-binary-math-operator-node"
import {
    GeometryBinaryMathOperatorNode,
    binaryMathOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/binary-math-operator/geometry-binary-math-operator-node"

export type MeshGeometryBinaryMathOperatorParameters = BinaryMathOperatorParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryBinaryMathOperatorParameters> = {
    nodeClass: "MeshGeometryBinaryMathOperator",
    validation: {
        parameters: binaryMathOperatorParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryBinaryMathOperator extends GeometryBinaryMathOperatorNode<2, MeshGeometryAttributeLikeNode> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
